import _ from 'lodash';
import { AnyAction } from 'redux';
import { entityCollectionDefaultState, EntityCollectionState } from '../entities/types/EntityCollectionState';
import {
    CLEAR_PARKED_CART,
    PARK_CART,
    REQUEST_MY_OFFERS,
    REQUEST_MY_OFFERS_FAILURE,
    REQUEST_MY_OFFERS_SUCCESS,
    REQUEST_OFFERS,
    REQUEST_OFFERS_FAILURE,
    REQUEST_OFFERS_SUCCESS,
} from './action';

/**
 * Fetch my offers
 */
export function myOffersReducer(state: EntityCollectionState<any> = entityCollectionDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_MY_OFFERS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case REQUEST_MY_OFFERS_SUCCESS:
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        case REQUEST_MY_OFFERS_FAILURE:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}

/**
 * Fetch offers
 */
export function offersReducer(state: EntityCollectionState<any> = entityCollectionDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_OFFERS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case REQUEST_OFFERS_SUCCESS:
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        case REQUEST_OFFERS_FAILURE:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}

/** R65 item 1: the offer applyOffer loaded into the cart and the shop goods it parked (raw cart content). */
export interface ParkedCartState {
    offerPublicId?: string;
    cart?: any;
}

export function parkedCartReducer(state: ParkedCartState = {}, action: AnyAction): ParkedCartState {
    switch (action.type) {
        case PARK_CART:
            return { offerPublicId: action.offerPublicId, cart: action.cart };
        case CLEAR_PARKED_CART:
            return {};
        default:
            return state;
    }
}
